import type { RadialGradientBGProps } from '@jouzen/ecom-components';
import { GridItem, LayoutGrid } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';

import LandingPageCard from './LandingPageCard';
import type {
  LandingPageCardData,
  LandingPageCardImageAspectRatio,
} from './types';

export interface LandingPageCardsProps {
  readonly cards: LandingPageCardData[];
  readonly imageAspectRatio?: LandingPageCardImageAspectRatio;
  readonly gradient?: RadialGradientBGProps | undefined;
  readonly gridClassName?: string | undefined;
}

const LandingPageCards = ({
  cards,
  imageAspectRatio,
  gradient,
  gridClassName,
}: LandingPageCardsProps) => {
  return (
    <LayoutGrid>
      <GridItem
        className="z-10"
        colEnd={{ sm: 'main', md: 20, lg: 'main' }}
        colStart={{ sm: 'main', md: 6, lg: 'main' }}
      >
        <ul
          className={cx(
            'grid gap-x-8 gap-y-20',
            {
              'lg:grid-cols-2': !gridClassName && cards.length === 2,
              'lg:grid-cols-3': !gridClassName && cards.length === 3,
              'lg:grid-cols-4': !gridClassName && cards.length >= 4,
            },
            gridClassName,
          )}
          data-cy="landing-page-cards-list"
        >
          {cards.map((card, i) => (
            <li key={card.id}>
              <LandingPageCard
                cardsCount={cards.length}
                imageGradientBg={gradient}
                imageAspectRatio={imageAspectRatio ?? '1:1'}
                index={i}
                {...card}
              />
            </li>
          ))}
        </ul>
      </GridItem>
    </LayoutGrid>
  );
};

export default LandingPageCards;
